/**
 * Parse ElevenLabs API error payloads (JSON or arraybuffer-encoded JSON).
 */
export async function parseSpeechApiError(response: Response): Promise<string> {
  try {
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      const data = await response.json();
      return (
        data.message ||
        data.error ||
        data.details ||
        `Speech request failed (${response.status})`
      );
    }

    const text = await response.text();
    if (!text) return `Speech request failed (${response.status})`;

    try {
      const data = JSON.parse(text);
      return data.message || data.error || data.detail?.message || text;
    } catch {
      return text;
    }
  } catch {
    return `Speech request failed (${response.status})`;
  }
}
